// DEV-2065 — Ürün içi entegrasyonlar: program içindeki ilgili alanlarda gösterilen
// tanıtım/yardım videolarının tek merkezî kaydı. Linkler değişirse yalnızca burası güncellenir.
// Değer = YouTube video id'si (https://youtu.be/<id>).
export const RehberVideolari = {
  tercihler: "LLRgZWkxmmI",
  kullaniciIzinleri: "g7Qh_WWbAdw",
  ajanda: "5na5Lqbhl3w",
  vekaletler: "IicQXniFA28",
  buroEkleme: "7lQTewH7WvA",
  faizHesaplayici: "WzPWj05_lGc",
  isListesi: "XxWfkN1kfN4",
  notlar: "cD4JUDBIt70",
  dilekceler: "0Dxs7fUD0Og",
  raporlar: "YDA6UmP1ylA",
  takipListesi: "NjJ9Dd3UDg0",
  topluXml: "FTadl9vUShY",
  takipAcma: "rHJqAWLvjT8",
  sifreDegistirme: "jl_kXj5wF2E",
  genelKullanim: "XdiDfWsYeGc",
  eicraproMtsTakip: "e5yMM7qQt_0",
} as const;
